import React, { useState } from 'react';
import { Sword, Shield, Zap, Skull } from 'lucide-react';

// v2.8 QoL #8: rich intent tooltip w/ effective damage and status
export default function EnemyIntent({ intent, enemy, player }) {
  const [hover, setHover] = useState(false);
  if (!intent) return null;
  let cls = 'intent';
  let Icon = Sword;
  if (intent.type === 'block') { cls += ' block'; Icon = Shield; }
  else if (intent.type === 'buff') { cls += ' buff'; Icon = Zap; }
  else if (intent.type === 'debuff') { cls += ' buff'; Icon = Skull; }
  else Icon = Sword;

  const dmgLabel = intent.type === 'attack'
    ? `${intent.value}${intent.hits ? ` x${intent.hits}` : ''}`
    : intent.type === 'block' ? `+${intent.value}`
    : intent.type === 'buff' ? `+${intent.value} ${intent.buff}`
    : `${intent.value} ${intent.debuff}`;

  // v2.8: compute EFFECTIVE damage considering strength, weak, vulnerable, block
  let effective = null;
  if (intent.type === 'attack' && enemy && player) {
    let base = intent.value + (enemy.strength || 0);
    if (enemy.dmgMult && enemy.dmgMult !== 1) base = Math.floor(base * enemy.dmgMult);
    if (enemy.weak > 0) base = Math.floor(base * 0.75);
    if (player.vulnerable > 0) base = Math.floor(base * 1.5);
    const hits = intent.hits || 1;
    const totalRaw = base * hits;
    const afterBlock = Math.max(0, totalRaw - (player.block || 0));
    effective = { perHit: base, hits, totalRaw, afterBlock };
  }

  return (
    <div
      className={cls}
      data-testid="enemy-intent"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ position: 'relative' }}
    >
      <Icon size={14} />
      <span data-testid="enemy-intent-value">{dmgLabel}</span>
      <span className="opacity-60">·</span>
      <span data-testid="enemy-intent-label">{intent.label}</span>
      {hover && (
        <div
          className="brutal-border-dim bg-[#0a0a0a] p-2 text-[10px] font-mono uppercase tracking-widest"
          data-testid="enemy-intent-tooltip"
          style={{ position: 'absolute', top: '110%', left: 0, minWidth: 200, zIndex: 20, borderColor: 'var(--red)', boxShadow: '3px 3px 0 var(--red)' }}
        >
          <div className="text-[color:var(--red)] font-black">{(intent.label || intent.type).toUpperCase()}</div>
          {intent.type === 'attack' && effective && (
            <>
              <div className="mt-1 text-white">
                RAW: <span className="text-[color:var(--pink)]">{effective.perHit}</span>
                {effective.hits > 1 && <> × <span className="text-[color:var(--pink)]">{effective.hits}</span> = <span className="text-[color:var(--pink)]">{effective.totalRaw}</span></>}
              </div>
              <div className="text-white">
                AFTER BLOCK: <span className="text-[color:var(--neon)]">{effective.afterBlock}</span>
              </div>
              {enemy && enemy.weak > 0 && <div className="text-[color:var(--neon)]">(enemy WEAK · -25% dmg)</div>}
              {player && player.vulnerable > 0 && <div className="text-[color:var(--red)]">(you VULN · +50% dmg)</div>}
            </>
          )}
          {intent.type === 'block' && (
            <div className="mt-1 text-[color:var(--neon)]">GAINS {intent.value} BLOCK</div>
          )}
          {intent.type === 'buff' && (
            <div className="mt-1 text-[color:var(--pink)]">+{intent.value} {intent.buff?.toUpperCase()}</div>
          )}
          {intent.type === 'debuff' && (
            <div className="mt-1 text-[color:var(--red)]">APPLIES {intent.value} {intent.debuff?.toUpperCase()}</div>
          )}
        </div>
      )}
    </div>
  );
}
